__turbopack_context__.v({
  "cancelIcon": "QrScanner-module__WHp5mq__cancelIcon",
  "icon": "QrScanner-module__WHp5mq__icon",
  "loadError": "QrScanner-module__WHp5mq__loadError",
  "loadErrorActions": "QrScanner-module__WHp5mq__loadErrorActions",
  "loading": "QrScanner-module__WHp5mq__loading",
  "loadingContainer": "QrScanner-module__WHp5mq__loadingContainer",
  "modal": "QrScanner-module__WHp5mq__modal",
  "scanCode": "QrScanner-module__WHp5mq__scanCode",
  "scanCodeAngle": "QrScanner-module__WHp5mq__scanCodeAngle",
  "scanCodeAngleBottom": "QrScanner-module__WHp5mq__scanCodeAngleBottom",
  "scanCodeAngleTop": "QrScanner-module__WHp5mq__scanCodeAngleTop",
});
